<template>
  <!-- <div> -->
  <el-button
    v-has="241020"
    icon="el-icon-download"
    :loading="loading"
    @click="handleDownload"
    class="noActive"
    size="small"
    data-html2canvas-ignore>
    <slot></slot>
  </el-button>
  <!-- </div> -->
</template>

<script>
import * as XLSX from 'xlsx'; // 导入 xlsx 库
import { saveAs } from 'file-saver'; // 导入 file-saver 库

import hasDirectives from '@/directives/has';

export default {
  name: 'MultiSheetExcelExporter',
  directives: {
    has: hasDirectives,
  },
  props: {
    excel_info: {
      type: Array,
      default: () => [
        // sheet
        {
          data: [],
          fields: {},
          name: '',
        },
      ],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    file_name: String,
  },
  data() {
    return {};
  },
  methods: {
    // 辅助函数：根据字段定义提取标题和键
    getHeadersAndKeys(fields) {
      if (!fields) return { headers: [], keys: [] };
      const headers = Object.values(fields);
      const keys = Object.keys(fields);
      return { headers, keys };
    },
    handleDownload() {
      this.$emit(
        'download-before',
        // 点击下载时获取数据在触发表格下载
        () => {
          this.$nextTick(() => {
            this.exportMultiSheetExcel();
          });
        }
      );
    },
    exportMultiSheetExcel() {
      const workbook = XLSX.utils.book_new();

      const excel_info = this.excel_info;

      excel_info.forEach(({ name, fields, data: excel_data }) => {
        const { headers, keys } = this.getHeadersAndKeys(fields);
        let _data = excel_data;
        if (Object.keys(excel_data[0] || {}).length !== Object.keys(fields).length) {
          // 过滤多余数据，只保留 fields 中定义的数据
          _data = excel_data.map((item) => {
            return keys.reduce((p, c) => {
              p[c] = item[c];
              return p;
            }, {});
          });
        }
        const _name = name.replace(/[\\\/\?\*\[\]]/g, ' ');
        const worksheet = XLSX.utils.json_to_sheet(_data, { header: keys });
        XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });
        XLSX.utils.book_append_sheet(workbook, worksheet, _name);
      });

      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });
      const fileName = this.file_name || '下载表格' + '.xlsx';
      saveAs(data, fileName);
    },
  },
};
</script>

<style scoped lang="less">
span {
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.el-button {
  font-size: 14;
  font-weight: 400;
  letter-spacing: 0.1px;
  height: 30px;
  // border: 1px solid #49495b !important;
}
.noActive {
  background-color: var(--Btn-bgc2) !important;
  // color: var(--stock_area_item_color2) !important;
  color: var(--stock_area_item_color1) !important;
  border: 1px solid var(--Btn-borderColor) !important;
  // border: 1px solid #49495b !important;
}

::v-deep .el-icon-download {
  color: var(--Btn-download-color);
  font-weight: 700;
  float: left;
}

.el-button:hover {
  background-color: var(--Btn-bgc_hover) !important;
  color: var(--Btn-color2) !important;
  // border: 1px solid var(--Btn-brc) !important;
  border: 1px solid var(--primary-color) !important;
}
</style>
